module.exports = __webpack_public_path__ + "img/arrow-left.99335fa6.svg";